/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var getSiblings = function (elem) {

	// Setup siblings array and get the first sibling
	var siblings = [];
	var sibling = elem.parentNode.firstChild;

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling
	}

	return siblings;

};

 if( document.body.contains( document.querySelector( '.NavPills' ) ) ) {
  var elNavItem = document.querySelectorAll('.NavPills .NavItem');
  for(var i = 0; i < elNavItem.length; i++){
    elNavItem[i].addEventListener('click', function () {
      this.classList.add('active');
      var elTargetTabPane = document.querySelector(this.getAttribute('data-target')),
          elTargetTabPaneSiblings = getSiblings(elTargetTabPane),
          elTargetNavItemSiblings = getSiblings(this)

      ;
      elTargetTabPane.classList.add('active');
      for(var i = 0; i < elTargetTabPaneSiblings.length; i++){
        elTargetTabPaneSiblings[i].classList.remove('active');
      }
      for(var i = 0; i < elTargetNavItemSiblings.length; i++){
        elTargetNavItemSiblings[i].classList.remove('active');
      }
    });
  }
}